import { RadioGroupField, RadioGroupFieldProps } from 'components/form'
import { RastreioCancerPerguntaOpcaoEnum } from 'graphql/types.generated'

const options = [
  { value: RastreioCancerPerguntaOpcaoEnum.RASTREAMENTO, label: 'Rastreamento' },
  { value: RastreioCancerPerguntaOpcaoEnum.REPETICAO, label: 'Repetição (exame alterado ASCUS/Baixo grau)' },
  { value: RastreioCancerPerguntaOpcaoEnum.SEGUIMENTO, label: 'Seguimento' },
]

export function MotivoExameRadioField(
  props: Readonly<Omit<RadioGroupFieldProps<RastreioCancerPerguntaOpcaoEnum>, 'options'>>
) {
  return <RadioGroupField label='Motivo do exame' lines={2} {...props} options={options} />
}
